import { render, staticRenderFns } from "./Positioning.vue?vue&type=template&id=7a0f6aa6"
import script from "./Positioning.vue?vue&type=script&lang=js"
export * from "./Positioning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports